(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  const start = () => {
    const targets = document.querySelectorAll('.elemi-section, .elemi-applications, .elemi-about-intro, .elemi-page-content > *, .elemi-product, .elemi-ritual');
    document.documentElement.classList.add('elemi-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('elemi-in-view');
        observer.unobserve(entry.target);
      });
    }, {threshold: 0.12, rootMargin: '0px 0px -5%'});
    targets.forEach((element, index) => {
      element.style.setProperty('--elemi-delay', `${Math.min(index % 4, 3) * 90}ms`);
      observer.observe(element);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
